module.exports = __webpack_public_path__ + "img/queue-int.3a0ffe0c.png";